<!--
 * @Author       : 四川华西绿舍建材有限公司
 * @Date         : 2023-09-11 08:57:14
 * @LastEditTime : 2025-10-31 15:41:24
 * @LastEditors  : yangxr
 * @Description  :  过磅任务
 * @FilePath     : \icps_fb\src\views\platform\ICPS\GHnumber\weightTask.vue
-->
<template>
  <div class="pages_content table">
    <el-container>
      <el-header>
        <breaDcrumb />
      </el-header>
      <el-main>
        <div class="tabtop">
          <div v-for="(item, index) in tableType" :key="index" @click="choose(item.id)">
            <div :class="currenindex == index + 1 ? 'active' : 'text'">{{ item.value }}</div>
          </div>
        </div>
        <div>
          <div class="search">
            <span style="display: inline-block; margin-bottom: 10px">
              <span style="margin-right: 12px">任务类型</span>
              <el-select v-model="tableParam.taskType" style="width: 110px" placeholder="请选择" clearable>
                <el-option v-for="item in taskTypeList" :key="item.id" :label="item.name" :value="item.id"></el-option>
              </el-select>
            </span>
            <span v-if="currenindex == 1" style="margin-left: 24px">
              <span style="margin-right: 12px">站点名称</span>
              <el-select v-model="tableParam.stationName" style="width: 110px" placeholder="请选择" clearable>
                <el-option v-for="item in stationIdlist" :key="item.name" :label="item.name"
                  :value="item.name" @click.native="tableParam.stationId = item.id"></el-option>
              </el-select>
            </span>
            <span v-if="currenindex == 2" style="margin-left: 24px">
              <span style="margin-right: 12px">站点名称</span>
              <el-select v-model="tableParam.stationId" style="width: 110px" placeholder="请选择" clearable>
                <el-option v-for="item in stationIdlist" :key="item.id" :label="item.name" :value="item.id" @click.native="tableParam.stationName = item.name"></el-option>
              </el-select>
            </span>
            <span style="margin-left: 24px">
              <span style="margin-right: 12px">车牌号</span>
              <el-input v-model="tableParam.carNo" style="width: 20%; max-width: 150px" clearable placeholder="请输入" />
            </span>
            <span style="margin-left: 24px">
              <span style="margin-right: 12px">创建时间</span>
              <el-date-picker v-model="startTimDateEndTimDate1" type="datetimerange" unlink-panels
                value-format="yyyy-MM-dd HH:mm:ss" start-placeholder="开始时间" end-placeholder="结束时间"></el-date-picker>
            </span>
            <template v-if="currenindex == 1">
              <span style="margin-left: 24px">
                <span style="margin-right: 12px">第一次过磅时间</span>
                <el-date-picker v-model="startTimDateEndTimDate2" type="datetimerange" unlink-panels
                  value-format="yyyy-MM-dd HH:mm:ss" start-placeholder="开始时间" end-placeholder="结束时间"></el-date-picker>
              </span>
              <span style="margin-left: 24px">
                <span style="margin-right: 12px">第二次过磅时间</span>
                <el-date-picker v-model="startTimDateEndTimDate3" type="datetimerange" unlink-panels
                  value-format="yyyy-MM-dd HH:mm:ss" start-placeholder="开始时间" end-placeholder="结束时间"></el-date-picker>
              </span>
            </template>
            <span v-if="currenindex == 1" style="margin-left: 24px">
              <span style="margin-right: 12px">推送状态</span>
              <el-select v-model="tableParam.sendUnatendedWeightStatus" style="width: 110px" placeholder="请选择" clearable>
                <el-option v-for="item in sendUnattendedWeightStatusListSearch" :key="item.id" :label="item.name"
                  :value="item.id"></el-option>
              </el-select>
            </span>
            <span v-if="currenindex == 2" style="margin-left: 24px">
              <span style="margin-right: 12px">推送状态</span>
              <el-select v-model="tableParam.sendDataStatus" style="width: 110px" placeholder="请选择" clearable>
                <el-option v-for="item in sendUnattendedWeightStatusList2" :key="item.id" :label="item.name"
                  :value="item.id"></el-option>
              </el-select>
            </span>
            <el-button icon="el-icon-search" size="medium" class="bottom_all but1"
              @click="(tableParam.page = 1), gettableDataNew()">查 询</el-button>
            <el-button size="medium" class="bottom_all_two" style="margin-left: 12px" @click="init()">重 置</el-button>
          </div>
        </div>
        <div class="hr"></div>
        <div class="card">
          <div class="card_nav">
            <div>
              <el-dropdown v-if="currenindex == 1" :hide-on-click="false" trigger="click">
                <el-button size="small" class="bottom_all" style="margin-left: 0">
                  <i class="icon iconfont iconicon_button_add" style="font-size: 12px"></i>
                  添加
                </el-button>
                <el-dropdown-menu slot="dropdown" style="text-align: left">
                  <el-dropdown-item>
                    <el-button size="mini" style="margin: 5px 0" class="bottom_one"
                      @click="$router.push('GHnumberDemand')">原物料采购</el-button>
                  </el-dropdown-item>
                  <el-dropdown-item>
                    <el-button size="mini" style="margin: 5px 0" class="bottom_one"
                      @click="$router.push('GHnumberGoods')">原物料退货</el-button>
                  </el-dropdown-item>
                  <el-dropdown-item>
                    <el-button size="mini" style="margin: 5px 0" class="bottom_one"
                      @click="$router.push('sellMaterialTask')">原物料售料</el-button>
                  </el-dropdown-item>
                  <el-dropdown-item>
                    <el-button size="mini" style="margin: 5px 0" class="bottom_one"
                      @click="$router.push('smartschedulj')">混凝土出场</el-button>
                  </el-dropdown-item>
                  <el-dropdown-item>
                    <el-button size="mini" style="margin: 5px 0" class="bottom_one"
                      @click="$router.push('smartschedulj')">混凝土回场</el-button>
                  </el-dropdown-item>
                  <el-dropdown-item>
                    <el-button size="mini" style="margin: 5px 0" class="bottom_one"
                      @click="$router.push('tareTask')">皮重任务</el-button>
                  </el-dropdown-item>
                  <el-dropdown-item>
                    <el-button size="mini" style="margin: 5px 0" class="bottom_one"
                      @click="$router.push('smart_specialmaterial_Deplan')">特材库入库</el-button>
                  </el-dropdown-item>
                  <el-dropdown-item>
                    <el-button size="mini" style="margin: 5px 0" class="bottom_one"
                      @click="$router.push('smart_warehouseADRN')">特材库返料</el-button>
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
            <div>
              <el-dropdown :hide-on-click="false" trigger="click" style="margin: 0 20px">
                <el-link :underline="false">
                  <span class="el-icon--left">
                    <i class="iconfont iconicon_button_filtrate"></i>
                  </span>
                  筛选
                </el-link>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item v-for="(item, index) in table" :key="index">
                    <el-checkbox v-model="item.status">{{ item.label }}</el-checkbox>
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
          </div>
          <div v-loading="tableLoading" class="card_info" :style="{ height: screenHeight - 510 }">
            <el-table :header-cell-style="{ background: '#f3f6f9' }" :height="screenHeight - 510"
              :cell-style="{ borderRight: 'none' }" border stripe style="width: 100%" :data="tableData"
              tooltip-effect="dark">
              <template v-for="(item, index2) in table">
                <el-table-column
                  v-if="item.status && (item.showType ? item.showType.some(some1 => some1 == tableParam.taskType) : true)"
                  :key="index2" :label="item.label" align="center" :width="item.width">
                  <template slot-scope="scope">
                    <div v-if="item.label == '第一次过磅照片'">
                      <el-button size="mini" class="bottom_one"
                        @click="look1Fun(scope.row.firstWeightPictureUrl)">查看</el-button>
                    </div>
                    <div v-else-if="item.label == '第二次过磅照片'">
                      <el-button size="mini" class="bottom_one"
                        @click="look1Fun(scope.row.secondWeightPictureUrl)">查看</el-button>
                    </div>
                    <div v-else-if="item.label == '是否补单'">
                      <span v-if="scope.row.supplementaryOrdersStatus == 0">否</span>
                      <span v-if="scope.row.supplementaryOrdersStatus == 1">是</span>
                      <span v-if="scope.row.supplementaryOrdersStatus == 2">已补单</span>
                    </div>
                    <div v-else-if="item.label == '过磅控制'">
                      <span v-if="scope.row.weightControl == 0">不允许过磅</span>
                      <span v-if="scope.row.weightControl == 1">允许过磅</span>
                    </div>
                    <div v-else-if="item.label == '完成状态'">
                      <span v-if="scope.row.completionStatus == 0">未完成</span>
                      <span v-if="scope.row.completionStatus == 1">已完成</span>
                    </div>
                    <div v-else-if="item.label == '推送状态' && currenindex == 1">
                      <span>{{ scope.row.sendUnattendedWeightStatus || scope.row.sendUnattendedWeightStatus == 0 ?
                        sendUnattendedWeightStatusList[scope.row.sendUnattendedWeightStatus * 1]?.name : "不推送" }}</span>
                    </div>
                    <div v-else-if="item.label == '推送状态' && currenindex == 2">
                      <span>{{ sendUnattendedWeightStatusList2[scope.row.sendDataStatus * 1]?.name }}</span>
                    </div>
                    <div v-else-if="item.label == '任务类型'">
                      <span>{{ taskTypeList[scope.row.taskType * 1 - 1]?.name }}</span>
                    </div>
                    <div v-else-if="item.label == '操作'">
                      <div v-if="currenindex == 1">
                        <el-button size="mini" class="bottom_one" @click="printDetail(scope.row)">打印</el-button>
                        <el-button
                          v-if="(scope.row.taskType == 1 || scope.row.taskType == 3) && !scope.row.secondWeightTime && scope.row.supplementaryOrdersStatus == 0"
                          size="mini" class="bottom_one" @click="changeTask(scope.row)">修改</el-button>
                        <el-button v-if="(scope.row.taskType == 1 || scope.row.taskType == 7 || scope.row.taskType == 8) &&
                          scope.row.sendUnattendedWeightStatus != 5 &&
                          !scope.row.sendUnattendedWeightStatus &&
                          scope.row.sendUnattendedWeightStatus != 0
                          " size="mini" class="bottom_one" @click="sendTask(scope.row)">推送无人值守</el-button>
                      </div>
                      <el-button v-if="currenindex == 2 && scope.row.sendDataStatus == 1" size="mini" class="bottom_one"
                        @click="association(scope.row)">自动关联</el-button>
                    </div>
                    <span v-else>{{ scope.row[item.prop] }}</span>
                  </template>
                </el-table-column>
              </template>
            </el-table>
          </div>
        </div>
      </el-main>
      <div class="card_bottom">
        <div class="card_bottom_left">
          <div class="top_page_totle">总共{{ total }}条</div>
          <el-pagination :current-page.sync="tableParam.page" :page-size="tableParam.pageSize"
            :page-sizes="[10, 20, 30, 40, 50, 100, 200, 500, 1000]" layout="prev,pager,sizes,next,jumper" :total="total"
            @size-change="sizeChange" @current-change="gettableDataNew()"></el-pagination>
        </div>
        <div>
          <el-button size="mini" icon="el-icon-refresh-right" class="bottom_all_two" @click="gettableDataNew">刷新</el-button>
        </div>
      </div>
    </el-container>
    <!-- 修改 -->
    <el-dialog v-dialogDrag :visible.sync="updateDig" width="580px" :close-on-click-modal="false">
      <span slot="title" class="dialog-title"> 修改任务 </span>
      <div class="dialoginfo">
        <el-form ref="reffromDate" :inline="true" :model="fromDate" label-width="110px" hide-required-asterisk>
          <el-form-item>
            <span slot="label">站点</span>
            {{ low.stationName }}
          </el-form-item>
          <el-form-item>
            {{ taskTypeList[low.taskType * 1 - 1].name }}
          </el-form-item>
          <el-form-item>
            <span slot="label">车牌号</span>
            {{ low.carNo }}
          </el-form-item>
          <el-form-item>
            <span slot="label">过磅控制</span>
            <el-radio-group v-model="fromDate.weightControl">
              <el-radio :label="1">允许</el-radio>
              <el-radio :label="0">不允许</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item>
            <span slot="label">库存仓</span>
            <el-select v-model="fromDate.warehouseCode" style="width: 110px" placeholder="请选择" clearable>
              <el-option v-for="item in warehouseList" :key="item.id" :label="item.name" :value="item.id"
                @click.native="fromDate.warehouse = item.name"></el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="bottom_all_two" @click="updateDig = false">取 消</el-button>
        <el-button class="bottom_all" style="margin-left: 24px" @click="saveTask()">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 补单数据列表 -->
    <el-dialog v-dialogDrag :visible.sync="repairTaskDig" width="980px" :close-on-click-modal="false">
      <span slot="title" class="dialog-title"> 补单任务列表 </span>
      <div class="dialoginfo">
        <span>无法自动关联，请手动选择补单任务</span>
        <div class="search">
          <span style="display: inline-block; margin-bottom: 10px">
            <span style="margin-right: 12px">车牌号</span>
            <el-input v-model="repairTaskParams.carNo" style="width: 150px" clearable placeholder="请输入" />
          </span>
          <span style="margin-left: 24px">
            <span style="margin-right: 12px">创建时间</span>
            <el-date-picker v-model="startTimDateEndTimDate4" style="width: 300px" type="datetimerange" unlink-panels
              value-format="yyyy-MM-dd HH:mm:ss" start-placeholder="开始时间" end-placeholder="结束时间"></el-date-picker>
          </span>
          <el-button icon="el-icon-search" size="medium" class="bottom_all but1"
            @click="(repairTaskParams.page = 1), queryRepairTaskPage()">查 询</el-button>
          <el-button size="medium" class="bottom_all_two" style="margin-left: 12px" @click="init2()">重 置</el-button>
        </div>
        <div class="card" style="margin-top: 20px">
          <div class="card_info">
            <el-table :header-cell-style="{ background: '#f3f6f9' }" :cell-style="{ borderRight: 'none' }" border stripe
              style="width: 100%" :data="repairTaskData" tooltip-effect="dark">
              <el-table-column width="55">
                <template slot-scope="scope">
                  <el-radio v-model="repairTaskForm.taskNo" :label="scope.row.taskNo">{{ "" }}</el-radio>
                </template>
              </el-table-column>
              <el-table-column label="业务系统任务编号" align="center" prop="taskNo"> </el-table-column>
              <el-table-column label="任务类型" align="center" prop="taskType">
                <template slot-scope="scope">
                  <span>{{ taskTypeList[scope.row.taskType * 1 - 1].name }}</span>
                  <span></span>
                </template>
              </el-table-column>
              <el-table-column label="车牌号" align="center" prop="carNo"> </el-table-column>
              <el-table-column label="站点名称" align="center" prop="stationName"> </el-table-column>
              <el-table-column label="创建时间" align="center" prop="createTime"> </el-table-column>
            </el-table>
          </div>
        </div>
        <div class="card_bottom">
          <div class="card_bottom_left">
            <div class="top_page_totle">总共{{ total }}条</div>
            <el-pagination :current-page.sync="repairTaskParams.page" :page-size="repairTaskParams.pageSize"
              :page-sizes="[10, 20, 30, 40, 50, 100, 200, 500, 1000]" layout="prev,pager,sizes,next,jumper"
              :total="repairTaskParams.total" @size-change="sizeChange2"
              @current-change="queryRepairTaskPage()"></el-pagination>
          </div>
          <div>
            <el-button size="mini" icon="el-icon-refresh-right" class="bottom_all_two"
              @click="queryRepairTaskPage">刷新</el-button>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="bottom_all_two" @click="repairTaskDig = false">取 消</el-button>
        <el-button class="bottom_all" style="margin-left: 24px" @click="saveAssociationTask()">确 定</el-button>
      </span>
    </el-dialog>
    <lookPicture :visible.sync="lookPictureDig" :urlList="urlList" />
    <!-- 罐车打印 -->
    <tankerDetailDialog :visible.sync="tankerDialog" :config="tankerPrintConfig"
      :printTemplateList="tankerPrintTemplateList" :stationId="tankerPrintConfig.productionSiteId" :status="tankerStatus"
      @gettable3="gettableDataNew" />
    <!-- 特材入库打印 -->
    <TCRKDetailDialog :visible.sync="tcrkDialog" :config="tcrkPrintConfig" :printTemplateList="tcrkPrintTemplateList"
      :status="tcrkStatus" :stationId="tcrkPrintConfig.stationId" />
    <!-- 原物料打印 -->
    <rawDetailDialog :visible.sync="rawDialog" :config="rawPrintConfig" :printTemplateList="rawPrintTemplateList"
      :stationId="rawPrintConfig.stationId" />
    <!-- 退料打印 -->
    <outRawDetailDialog :visible.sync="outRawDialog" :config="outRawPrintConfig"
      :printTemplateList="outRawPrintTemplateList" :stationId="outRawPrintConfig.stationId" />
    <!-- 售料打印 -->
    <inRawDetailDialog :visible.sync="inRawDialog" :config="inRawPrintConfig" :printTemplateList="inRawPrintTemplateList"
      :stationId="inRawPrintConfig.stationId" />
  </div>
</template>

<script>
import mixin from "@/mixins/ICPSmixin.js";
import { queryPage1, queryPage2, printTicket, queryWarehouseList, sendDataToUnatendedWeight, updateWeightTask, queryRepairTaskPage, associatedWeightTask, automaticAssociation } from "@/api/GHnumber/weightTask.js";
import { getUserAutList } from "@/api/common.js";
import tankerDetailDialog from "./weightPrint/tankerDetailDialog";
import TCRKDetailDialog from "./weightPrint/TCRKDetailDialog";
import rawDetailDialog from "./weightPrint/rawDetailDialog";
import outRawDetailDialog from "./weightPrint/outRawDetailDialog";
import inRawDetailDialog from "./weightPrint/inRawDetailDialog";
export default {
  mixins: [mixin],
  components: {
    lookPicture: () => import("@/components/File/lookPicture.vue"),
    tankerDetailDialog,
    TCRKDetailDialog,
    rawDetailDialog,
    outRawDetailDialog,
    inRawDetailDialog,
  },
  data() {
    return {
      disabledType: false,
      /*表格增删改查及下载接口*/
      queryPage: queryPage1,
      loading: false,
      /*表格数据*/
      table: [],
      table1: [
        {
          label: "业务系统任务编号",
          width: "",
          prop: "taskNo",
          status: true,
          showType: null,
        },
        {
          label: "任务类型",
          width: "",
          prop: "taskType",
          status: true,
          showType: null,
        },
        {
          label: "车牌号",
          width: "",
          prop: "carNo",
          status: true,
          showType: null,
        },
        {
          label: "站点名称",
          width: "",
          prop: "stationName",
          status: true,
          showType: null,
        },
        {
          label: "产品名称",
          width: "",
          prop: "productName",
          status: true,
          showType: [1, 2, 3, 4, 5, 7, 8],
        },
        {
          label: "协作单位",
          width: "",
          prop: "collaborativeUnits",
          status: true,
          showType: [1, 2],
        },
        {
          label: "快检含水率",
          width: "",
          prop: "moistureContent",
          status: true,
          showType: [1],
        },
        {
          label: "库存仓",
          width: "",
          prop: "warehouse",
          status: true,
          showType: [1, 2, 3, 7, 8],
        },
        {
          label: "创建时间",
          width: "",
          prop: "createTime",
          status: true,
          showType: null,
        },
        {
          label: "第一次过磅时间",
          width: "",
          prop: "firstWeightTime",
          status: true,
          showType: null,
        },
        {
          label: "第一次过磅量（吨）",
          width: "",
          prop: "firstWeight",
          status: true,
          showType: null,
        },
        {
          label: "第一次过磅照片",
          width: "",
          prop: "firstWeightPictureUrl",
          status: true,
          showType: null,
        },
        {
          label: "第二次过磅时间",
          width: "",
          prop: "secondWeightTime",
          status: true,
          showType: [1, 2, 3, 7, 8],
        },
        {
          label: "第二次过磅量（吨）",
          width: "",
          prop: "secondWeight",
          status: true,
          showType: [1, 2, 3, 7, 8],
        },
        {
          label: "第二次过磅照片",
          width: "",
          prop: "secondWeightPictureUrl",
          status: true,
          showType: [1, 2, 3, 7, 8],
        },
        {
          label: "是否补单",
          width: "",
          prop: "supplementaryOrdersStatus",
          status: true,
          showType: null,
        },
        {
          label: "推送状态",
          width: "",
          prop: "sendUnattendedWeightStatus",
          status: true,
          showType: null,
        },
        {
          label: "操作",
          width: "360",
          prop: "",
          status: true,
          showType: null,
        },
      ],
      table2: [
        {
          label: "过磅任务编号",
          width: "",
          prop: "id",
          status: true,
        },
        {
          label: "业务系统任务编号",
          width: "",
          prop: "taskNo",
          status: true,
        },
        {
          label: "任务类型",
          width: "",
          prop: "taskType",
          status: true,
        },
        {
          label: "车牌号",
          width: "",
          prop: "carNo",
          status: true,
        },
        {
          label: "站点名称",
          width: "",
          prop: "stationName",
          status: true,
        },
        {
          label: "库存仓",
          width: "",
          prop: "warehouse",
          status: true,
        },
        {
          label: "创建时间",
          width: "",
          prop: "createTime",
          status: true,
        },
        {
          label: "第一次过磅时间",
          width: "",
          prop: "firstWeightTime",
          status: true,
        },
        {
          label: "第一次过磅量（吨）",
          width: "",
          prop: "firstWeight",
          status: true,
        },
        {
          label: "第二次过磅时间",
          width: "",
          prop: "secondWeightTime",
          status: true,
        },
        {
          label: "第二次过磅量（吨）",
          width: "",
          prop: "secondWeight",
          status: true,
        },
        {
          label: "过磅控制",
          width: "",
          prop: "weightControl",
          status: true,
        },
        {
          label: "完成状态",
          width: "",
          prop: "completionStatus",
          status: true,
        },
        {
          label: "推送状态",
          width: "",
          prop: "sendDataStatus",
          status: true,
        },
        {
          label: "操作",
          width: "240",
          prop: "",
          status: true,
        },
      ],
      /*表单页类型，0为无树状，1为有树状，有树状在el-main加上display:flex*/
      pagesType: 0,
      tableType: [
        {
          value: "过磅任务",
          id: 1,
        },
        {
          value: "无人值守",
          id: 2,
        },
      ],
      currenindex: 1,
      taskTypeList: [
        {
          name: "原物料过磅",
          id: 1,
        },
        {
          name: "退料",
          id: 2,
        },
        {
          name: "售料",
          id: 3,
        },
        {
          name: "罐车出站",
          id: 4,
        },
        {
          name: "罐车入站",
          id: 5,
        },
        {
          name: "罐车皮重",
          id: 6,
        },
        {
          name: "特材过磅",
          id: 7,
        },
        {
          name: "特材返料",
          id: 8,
        },
      ],
      sendUnattendedWeightStatusListSearch: [
        {
          name: "正常",
          id: 1,
        },
        {
          name: "异常",
          id: 2,
        },
        {
          name: "不推送",
          id: 3,
        },
      ],
      sendUnattendedWeightStatusList: [
        {
          name: "正常",
          id: 0,
        },
        {
          name: "添加异常",
          id: 1,
        },
        {
          name: "删除异常",
          id: 2,
        },
        {
          name: "修改异常",
          id: 3,
        },
        {
          name: "",
          id: 4,
        },
        {
          name: "不推送",
          id: 5,
        },
      ],
      sendUnattendedWeightStatusList2: [
        {
          name: "正常更新",
          id: 0,
        },
        {
          name: "异常",
          id: 1,
        },
      ],
      //打印相关
      //罐车
      tankerDialog: false,
      tankerPrintConfig: {},
      tankerPrintTemplateList: [],
      tankerStatus: "",
      //特材
      tcrkDialog: false,
      tcrkPrintConfig: {},
      tcrkPrintTemplateList: [],
      tcrkStatus: "",
      //原物料
      rawDialog: false,
      rawPrintConfig: {},
      rawPrintTemplateList: [],
      //退料
      outRawDialog: false,
      outRawPrintConfig: {},
      outRawPrintTemplateList: [],
      //售料
      inRawDialog: false,
      inRawPrintConfig: {},
      inRawPrintTemplateList: [],
      //修改
      warehouseList: [],
      updateDig: false,
      low: { taskType: 1 },
      /*添加表单数据*/
      fromDate: {
        taskType: "",
        taskNo: "",
        weightControl: "",
        warehouse: "",
        warehouseCode: "",
      },
      startTimDateEndTimDate1: [],
      startTimDateEndTimDate2: [],
      startTimDateEndTimDate3: [],
      startTimDateEndTimDate4: [],
      stationIdlist: [],
      urlList: [],
      lookPictureDig: false,
      //关联
      repairTaskParams: {
        page: 1,
        pageSize: 5,
        total: "",
      },
      repairTaskData: [],
      repairTaskDig: false,
      repairTaskForm: {},
    };
  },
  watch: {
    startTimDateEndTimDate1(val) {
      if (val?.length > 0) {
        this.tableParam.startTime = val[0];
        this.tableParam.endTime = val[1];
      } else {
        this.tableParam.startTime = "";
        this.tableParam.endTime = "";
      }
    },
    startTimDateEndTimDate2(val) {
      if (val?.length > 0) {
        this.tableParam.firstTimeStart = val[0];
        this.tableParam.firstTimeEnd = val[1];
      } else {
        this.tableParam.firstTimeStart = "";
        this.tableParam.firstTimeEnd = "";
      }
    },
    startTimDateEndTimDate3(val) {
      if (val?.length > 0) {
        this.tableParam.sencondTimeStart = val[0];
        this.tableParam.sencondTimeEnd = val[1];
      } else {
        this.tableParam.sencondTimeStart = "";
        this.tableParam.sencondTimeEnd = "";
      }
    },
    startTimDateEndTimDate4(val) {
      if (val?.length > 0) {
        this.repairTaskParams.startTime = val[0];
        this.repairTaskParams.endTime = val[1];
      } else {
        this.repairTaskParams.startTime = "";
        this.repairTaskParams.endTime = "";
      }
    },
  },
  async created() {
    this.stationIdlist = await getUserAutList(true);
    this.table = this.table1;
    let curTime = new Date().Format("yyyy-MM-dd hh:mm:ss");
    let startTime = new Date().Format("yyyy-MM-dd");
    startTime = new Date(startTime).getTime() - 24 * 60 * 60 * 1000;
    startTime = new Date(startTime).Format("yyyy-MM-dd") + " 00:00:00";
    this.startTimDateEndTimDate1 = [startTime, curTime]
    /*存储拷贝的原初始化fromDate数据*/
    this.tableParam = {
      ...this.tableParam,
      taskType: 1,
      sendUnattendedWeightStatus: "",
      stationName: "",
      carNo: "",
      startTime: "",
      endTime: "",
      firstTimeStart: "",
      firstTimeEnd: "",
      sencondTimeEnd: "",
      sencondTimeStart: "",
    };
    // this.gettableDataNew();
  },
  methods: {
    gettableDataNew(){
      if(!this.tableParam.stationName) {
        this.$message.warning('请选择站点!')
        return
      }
      this.gettableData()
    },
    //关联
    association(row) {
      this.repairTaskForm = {
        taskNo: row.taskNo,
        firstWeightTime: row.firstWeightTime,
        firstWeight: row.firstWeight,
        secondWeight: row.secondWeight,
        secondWeightTime: row.secondWeightTime,
        taskType: row.taskType,
        id: row.id,
        stationId: row.stationId,
      };
      automaticAssociation(this.repairTaskForm).then(async res => {
        if (res.data == false) {
          this.repairTaskParams = { ...this.repairTaskParams, taskType: row.taskType, stationId: row.stationId, carNo: "", startTime: "", endTime: "" };
          await this.queryRepairTaskPage();
          this.repairTaskDig = true;
        } else {
          this.$message.success("已自动关联!");
        }
      });
    },
    saveAssociationTask() {
      associatedWeightTask(this.repairTaskForm).then(res => {
        if (res.code == 1001) {
          this.$message.success("关联成功!");
          this.repairTaskDig = false;
        }
      });
    },
    queryRepairTaskPage() {
      console.log(this.repairTaskParams);
      queryRepairTaskPage(this.repairTaskParams).then(res => {
        if (res.code == 1001) {
          this.repairTaskData = res.data.data;
          this.repairTaskParams.total = res.data.totalRows;
        }
      });
    },
    init2() {
      this.repairTaskParams = { ...this.repairTaskParams, carNo: "", startTime: "", endTime: "" };
      this.queryRepairTaskPage();
    },
    sizeChange2(value) {
      this.repairTaskParams.pageSize = value;
      this.queryRepairTaskPage();
    },
    // 关联结束
    saveTask() {
      this.fromDate.taskNo = this.low.taskNo;
      this.fromDate.taskType = this.low.taskType;
      updateWeightTask(this.fromDate).then(res => {
        if (res.code == 1001) {
          this.$message.success("修改成功!");
          this.updateDig = false;
          this.gettableDataNew();
        }
      });
    },
    changeTask(row) {
      queryWarehouseList({
        rawId: row.rawId,
        stationId: row.stationId,
      }).then(res => {
        if (res.code == 1001) {
          this.warehouseList = res.data;
          this.updateDig = true;
          this.low = JSON.parse(JSON.stringify(row));
        }
      });
    },
    sendTask(row) {
      sendDataToUnatendedWeight({
        taskNo: row.taskNo,
        taskType: row.taskType,
      }).then(res => {
        if (res.code == 1001) {
          this.$message.success("已推送无人值守!");
          this.gettableDataNew();
        }
      });
    },
    printDetail(row) {
      printTicket({
        taskNo: row.taskNo,
        taskType: row.taskType,
      }).then(res => {
        if (res.code == 1001) {
          //罐车出入站
          if (row.taskType == 4 || row.taskType == 5 || row.taskType == 6) {
            console.log("1");
            this.tankerDialog = true;
            this.tankerPrintConfig = res.data.data;
            this.tankerPrintTemplateList = res.data.template;
            this.tankerStatus = row.taskType == 4 ? "CZ" : row.taskType == 5 ? "HZ" : "PZ";
          }
          if (row.taskType == 7 || row.taskType == 8) {
            console.log("2");
            this.tcrkDialog = true;
            this.tcrkPrintConfig = res.data.data;
            this.tcrkPrintTemplateList = res.data.template;
            this.tcrkStatus = row.taskType == 7 ? "TCRK" : "TCFL";
          }
          if (row.taskType == 1) {
            this.rawDialog = true;
            this.rawPrintConfig = res.data.data;
            this.rawPrintTemplateList = res.data.template;
          }
          if (row.taskType == 2) {
            this.outRawDialog = true;
            this.outRawPrintConfig = res.data.data;
            this.outRawPrintTemplateList = res.data.template;
          }
          if (row.taskType == 3) {
            this.inRawDialog = true;
            this.inRawPrintConfig = res.data.data;
            this.inRawPrintTemplateList = res.data.template;
          }
        }
      });
    },
    choose(num) {
      this.currenindex = num;
      if (this.currenindex == 1) {
        this.queryPage = queryPage1;
        this.table = this.table1;
        this.tableParam = {
          ...this.tableParam,
          taskType: 1,
          sendUnattendedWeightStatus: "",
          stationName: "",
          carNo: "",
          firstTimeStart: "",
          firstTimeEnd: "",
          sencondTimeEnd: "",
          sencondTimeStart: "",
        };
      }
      if (this.currenindex == 2) {
        this.queryPage = queryPage2;
        this.table = this.table2;
        this.tableParam = {
          ...this.tableParam,
          taskType: 1,
          sendUnattendedWeightStatus: "",
          carNo: "",
          sendDataStatus: "",
        };
      }
      this.gettableDataNew();
    },
    look1Fun(e) {
      this.lookPictureDig = true;
      this.urlList = e ? e.split(",") : [];
      console.log(this.urlList);
    },
    deleteTask() {
      this.$confirm("此操作将永久删除该信息?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        cancelButtonClass: "bottom_all_two",
        confirmButtonClass: "bottom_all",
        type: "warning",
      })
        .then(() => { })
        .catch(() => { });
    },
    init() {
      /*重置数据*/
      if (this.currenindex == 1) {
        this.tableParam = {
          ...this.tableParam,
          taskType: 1,
          sendUnattendedWeightStatus: "",
          stationName: "",
          carNo: "",
          startTime: "",
          endTime: "",
          firstTimeStart: "",
          firstTimeEnd: "",
          sencondTimeEnd: "",
          sencondTimeStart: "",
        };
      }
      if (this.currenindex == 2) {
        this.tableParam = {
          ...this.tableParam,
          taskType: 1,
          sendUnattendedWeightStatus: "",
          stationId: "",
          stationName: "",
          carNo: "",
          startTime: "",
          endTime: "",
          sendDataStatus: "",
        };
      }

      (this.startTimDateEndTimDate1 = []), (this.startTimDateEndTimDate2 = []), (this.startTimDateEndTimDate3 = []);
      let curTime = new Date().Format("yyyy-MM-dd hh:mm:ss");
      let startTime = new Date().Format("yyyy-MM-dd");
      startTime = new Date(startTime).getTime() - 24 * 60 * 60 * 1000;
      startTime = new Date(startTime).Format("yyyy-MM-dd") + " 00:00:00";
      this.startTimDateEndTimDate1 = [startTime, curTime]
      this.gettableDataNew();
    },
    submit() {
      let _this = this;
      _this.$refs.reffromDate.validate(valid => {
        if (valid) {
          _this.submitFromDate();
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    sizeChange(value) {
      this.tableParam.pageSize = value;
      this.gettableDataNew();
    },
  },
};
</script>

<style lang="scss" scoped>
.table_top {
  color: #008000;
}

.table_top:hover {
  color: #008000 !important;
  opacity: 0.8;
}

.el-input,
.el-select {
  width: 320px;
}

.table_link {
  margin-left: 10px;
  color: $bg_color;
}

.table_link:hover {
  opacity: 0.8;
}

.dialoginfo-title {
  >div {
    cursor: pointer;
  }

  height: 48px;
  display: flex;
  background: linear-gradient(180deg, rgba(250, 252, 255, 1) 0%, rgba(245, 247, 250, 1) 100%);

  .none {
    font-weight: bold;
    height: 48px;
    @include discen;
    width: calc(100% / 2);
    border-bottom: 1px solid #e1e5ed;

    >div {
      line-height: 48px;
      border-bottom: 1px rgba(0, 0, 0, 0) solid;
    }
  }

  .active {
    font-weight: bold;
    height: 48px;
    @include discen;
    width: calc(100% / 2);
    border: 1px solid #e1e5ed;
    border-bottom: 0;
    background: #ffffff;

    >div {
      color: $bg_color;
      line-height: 48px;
      border-bottom: 1px $bg_color solid;
    }
  }
}

.no-data {
  text-align: center;
}

.FZY ::v-deep .el-input-group__append {
  padding: 0px 8px;
}

.FZYimgMp4list {
  display: flex;
  flex-wrap: wrap;
}

.tabtop {
  width: 381px;
}

.receiveNum {
  .el-input__inner {
    width: 133px;
    height: 133px;
  }
}</style>